import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { TranslocoLocaleService } from '@ngneat/transloco-locale';
import { PricingInformation } from '@platform-frontend/marketplace';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../checkout-transloco-scope';

@Injectable({
  providedIn: 'root'
})
export class WalletPriceInlineItemsService {
  constructor(private translocoLocaleService: TranslocoLocaleService, private translocoService: TranslocoService) {}

  createGooglePayLineItems(businessModel: string, pricingInformation: PricingInformation): google.payments.api.DisplayItem[] {
    const lineItems: google.payments.api.DisplayItem[] = [];

    const addLineItem = (label: string, amount: number, type: google.payments.api.DisplayItemType): void => {
      const lineItem: google.payments.api.DisplayItem = { price: amount.toFixed(2), label, type };
      lineItems.push(lineItem);
    };

    if (businessModel === 'B2B') {
      addLineItem(
        this.translocoService.translate('paymentWallet.lineItems.flyOutSubtotal', {}, CHECKOUT_TRANSLOCO_SCOPE),
        pricingInformation.netValue,
        'SUBTOTAL'
      );

      if (pricingInformation.vatReversed) {
        addLineItem(
          this.translocoService.translate('paymentWallet.lineItems.flyOutVatReversed', {}, CHECKOUT_TRANSLOCO_SCOPE),
          pricingInformation.vatValue,
          'TAX'
        );
      } else {
        addLineItem(
          this.translocoService.translate(
            'paymentWallet.lineItems.flyOutVatB2B',
            { vatPercentage: this.translocoLocaleService.localizeNumber(pricingInformation.vatPercentage, 'percent') },
            CHECKOUT_TRANSLOCO_SCOPE
          ),
          pricingInformation.vatValue,
          'TAX'
        );
      }
    } else if (businessModel === 'B2C') {
      if (pricingInformation.vatReversed) {
        addLineItem(
          this.translocoService.translate('paymentWallet.lineItems.flyOutVatReversed', {}, CHECKOUT_TRANSLOCO_SCOPE),
          pricingInformation.vatValue,
          'TAX'
        );
      } else {
        addLineItem(
          this.translocoService.translate(
            'paymentWallet.lineItems.flyOutVatB2C',
            { vatPercentage: this.translocoLocaleService.localizeNumber(pricingInformation.vatPercentage, 'percent') },
            CHECKOUT_TRANSLOCO_SCOPE
          ),
          pricingInformation.vatValue,
          'TAX'
        );
      }
    }

    return lineItems;
  }

  createApplePayLineItems(businessModel: string, pricingInformation: PricingInformation): ApplePayJS.ApplePayLineItem[] {
    const googlePayLineItems = this.createGooglePayLineItems(businessModel, pricingInformation);
    return googlePayLineItems.map(lineItem => {
      return {
        label: lineItem.label,
        amount: lineItem.price,
        type: 'final'
      };
    });
  }
}
